module.exports = __webpack_public_path__ + "static/kuruyemisborsasi-web-276ddd79e4ba2564abcf8b7f05ab434a.jpg";